import { useState, useContext, createContext, Dispatch, SetStateAction, FC } from 'react'
import { useRouter } from 'next/router'

type ContextValueType = boolean
// Slug of the workspace the socket was opened for
type SetterValueType = string | null

interface Props {}


const SocketInitializationContext = createContext<ContextValueType>(false)
const SocketInitializationSetterContext = createContext<Dispatch<SetStateAction<SetterValueType>>>(() => null)

const SocketInitializationProvider: FC<Props> = ({ children }) => {
  const [socketWorkspace, setSocketWorkspace] = useState<SetterValueType>(null)
  const router = useRouter()

  // Ready only for the workspace the socket was opened for. A plain flag stayed true after a
  // client-side workspace switch, so the new page's subscribers ran before its socket existed.
  const socketInitialization = socketWorkspace !== null && socketWorkspace === router.query.application

  return (
    <SocketInitializationContext.Provider value={socketInitialization}>
      <SocketInitializationSetterContext.Provider value={setSocketWorkspace}>
        {children}
      </SocketInitializationSetterContext.Provider>
    </SocketInitializationContext.Provider>
  )
}

export function useSocketInitialization(): [ContextValueType, Dispatch<SetStateAction<SetterValueType>>] {
  const valueContext = useContext(SocketInitializationContext)
  const setterContext = useContext(SocketInitializationSetterContext)

  if (valueContext === undefined || valueContext === undefined) {
    throw 'useSocketInitialization must be used on child component of SocketInitializationProvider component'
  }

  return [valueContext, setterContext]
}

export default SocketInitializationProvider
